import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

export function initLightbox(): void {
  const galleryElements = document.getElementsByClassName('glightbox')
  if (galleryElements.length === 0) return

  const lightbox = GLightbox({
    closeOnOutsideClick: false,
  })

  lightbox.on('slide_changed', addNavigationZones.bind(null, lightbox))
  lightbox.on('open', addNavigationZones.bind(null, lightbox))
}

function addNavigationZones(lightbox: ReturnType<typeof GLightbox>): void {
  document.querySelectorAll('.glightbox-nav-zone').forEach((el) => el.remove())

  const container = document.querySelector('.gslide.current .gslide-media')
  if (!container) return

  const leftZone = createNavZone('left', () => lightbox.prevSlide())
  const rightZone = createNavZone('right', () => lightbox.nextSlide())

  container.appendChild(leftZone)
  container.appendChild(rightZone)
}

function createNavZone(side: 'left' | 'right', onClick: () => void): HTMLDivElement {
  const zone = document.createElement('div')
  zone.className = `glightbox-nav-zone glightbox-nav-zone--${side}`
  zone.addEventListener('click', (e) => {
    e.stopPropagation()
    onClick()
  })
  return zone
}
